var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jf-help-tooltip",attrs:{"v-jf-tooltip":_vm.html}},[_c('div',[_c('span',{staticClass:"tooltip-icon jf-tooltipster",on:{"click":function($event){return _vm.tooltipClick($event)}}},[_c('span',[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }